import { createInvoiceReminder } from "../../models/invoice-reminder.model";

export const invoiceReminderGetters = {
  invoiceReminderList: (state) => state.invoiceReminderList,
  selectedInvoiceReminder: (state) => createInvoiceReminder(state.selectedInvoiceReminder),
}